import type { ReturnToAddressOverrideModel } from '../assets/returnToAddressOverrides';
import { returnToAddressOverrideModel } from '../assets/returnToAddressOverrides';
import type { AddressesModel } from './addresses';
import { addressesModel } from './addresses';
import type { AugmentationSetsModel } from './augmentationSets';
import { augmentationSetsModel } from './augmentationSets';
import type { CarrierAccountsModel } from './carrierAccounts';
import { carrierAccountsModel } from './carrierAccounts';
import type { CarrierRateSetsModel } from './carrierRateSets';
import { carrierRateSetsModel } from './carrierRateSets';
import type { CarrierRatesModel } from './carrierRates';
import { carrierRatesModel } from './carrierRates';
import type { CarrierSelectionOverridesModel } from './carrierSelectionOverrides';
import { carrierSelectionOverridesModel } from './carrierSelectionOverrides';
import type { CarrierSettingsModel } from './carrierSettings';
import { carrierSettingsModel } from './carrierSettings';
import type { ContactsModel } from './contacts';
import { contactsModel } from './contacts';
import type { ContractsModel } from './contracts';
import { contractsModel } from './contracts';
import type { DockLaneSortConfigurationsModel } from './dockLaneSortConfigurations';
import dockLaneSortConfigurationsModel from './dockLaneSortConfigurations';
import type { DockLanesModel } from './dockLanes';
import dockLanesModel from './dockLanes';
import type { FulfillmentContextsModel } from './fulfillmentContexts';
import { fulfillmentContextsModel } from './fulfillmentContexts';
import type { InjectionProfilesModel } from './injectionProfiles';
import { injectionProfilesModel } from './injectionProfiles';
import type { InjectionSitesModel } from './injectionSites';
import { injectionSitesModel } from './injectionSites';
import type { LabelAugmentationsModel } from './labelAugmentations';
import { labelAugmentationsModel } from './labelAugmentations';
import type { LabelPropertiesModel } from './labelProperties';
import { labelPropertiesModel } from './labelProperties';
import type { OriginsModel } from './origins';
import { originsModel } from './origins';
import type { PackagingModel } from './packaging';
import { packagingModel } from './packaging';
import type { PackagingSetsModel } from './packagingSets';
import { packagingSetsModel } from './packagingSets';
import type { ReturnSettingsModel } from './returnSettings';
import { returnSettingsModel } from './returnSettings';
import type { SchedulesModel } from './schedules';
import { schedulesModel } from './schedules';
import type { TagsModel } from './tags';
import { tagsModel } from './tags';
import type { TenantsModel } from './tenants';
import { tenantsModel } from './tenants';
import type { ThirdPartyBillingAccountSetsModel } from './thirdPartyBillingAccountSets';
import { thirdPartyBillingAccountSetsModel } from './thirdPartyBillingAccountSets';
import type { ThirdPartyBillingAccountsModel } from './thirdPartyBillingAccounts';
import { thirdPartyBillingAccountsModel } from './thirdPartyBillingAccounts';

export interface ConfigurationAssetsModel {
  augmentationSets: AugmentationSetsModel;
  contacts: ContactsModel;
  addresses: AddressesModel;
  carrierAccounts: CarrierAccountsModel;
  carrierSelectionOverrides: CarrierSelectionOverridesModel;
  carrierSettings: CarrierSettingsModel;
  carrierRates: CarrierRatesModel;
  carrierRateSets: CarrierRateSetsModel;
  contracts: ContractsModel;
  fulfillmentContexts: FulfillmentContextsModel;
  injectionProfilesModel: InjectionProfilesModel;
  injectionSitesModel: InjectionSitesModel;
  labelAugmentations: LabelAugmentationsModel;
  labelProperties: LabelPropertiesModel;
  returnSettings: ReturnSettingsModel;
  returnToAddressOverrides: ReturnToAddressOverrideModel;
  schedules: SchedulesModel;
  origins: OriginsModel;
  packaging: PackagingModel;
  packagingSets: PackagingSetsModel;
  thirdPartyBillingAccounts: ThirdPartyBillingAccountsModel;
  thirdPartyBillingAccountSets: ThirdPartyBillingAccountSetsModel;
  tags: TagsModel;
  tenants: TenantsModel;
  dockLanes: DockLanesModel;
  dockLaneSortConfigurations: DockLaneSortConfigurationsModel;
}

export const configurationAssetsModel: ConfigurationAssetsModel = {
  augmentationSets: augmentationSetsModel,
  contacts: contactsModel,
  addresses: addressesModel,
  carrierSelectionOverrides: carrierSelectionOverridesModel,
  carrierAccounts: carrierAccountsModel,
  carrierSettings: carrierSettingsModel,
  carrierRates: carrierRatesModel,
  carrierRateSets: carrierRateSetsModel,
  contracts: contractsModel,
  dockLanes: dockLanesModel,
  dockLaneSortConfigurations: dockLaneSortConfigurationsModel,
  fulfillmentContexts: fulfillmentContextsModel,
  injectionProfilesModel: injectionProfilesModel,
  injectionSitesModel: injectionSitesModel,
  labelAugmentations: labelAugmentationsModel,
  labelProperties: labelPropertiesModel,
  returnSettings: returnSettingsModel,
  returnToAddressOverrides: returnToAddressOverrideModel,
  schedules: schedulesModel,
  origins: originsModel,
  packaging: packagingModel,
  packagingSets: packagingSetsModel,
  thirdPartyBillingAccounts: thirdPartyBillingAccountsModel,
  thirdPartyBillingAccountSets: thirdPartyBillingAccountSetsModel,
  tags: tagsModel,
  tenants: tenantsModel,
};
